import React, { useState } from "react";
import Logo from "../../assets/img/logo.png";
import { Form, FloatingLabel } from "react-bootstrap";
import { isEmpty } from "../../Actions/common";
import { adminlogin } from "../../Actions/axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const Login = () => {
  const navigate = useNavigate();
  const [login, setLogin] = useState({
    EmailId: "",
    password: "",
  });

  const [err, setErr] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setLogin({
      ...login,
      [name]: value,
    });
  };

  const validation = async () => {
    let error = {};
    await Promise.all(
      Object.keys(login)?.map((val) => {
        if (isEmpty(login[val])) {
          error[val] = `${val} is Required`;
        }
      })
    );
    setErr(error);
    return err;
  };

  const handleSummit = async () => {
    let error = await validation();
    if (!isEmpty(error)) {
      toast.error("Field Error");
    }
    let resp = await adminlogin(login);
    console.log("🚀 ~ handleSummit ~ resp:", resp);
    if (resp?.status) {
      localStorage.setItem('adminkey',resp?.data?.token)
      navigate("/assetlist");
    }
  };

  return (
    <section className="login">
      <div className="loginbox">
        <div className="loginbox_top">
          <div className="lockbox">
            <img
              src={Logo}
              alt="NOVA"
              className="img-fluid"
              width={50}
              height={50}
            />
          </div>
          <p className="login_head text-center">Sign in</p>
        </div>
        <div className="loginbox_body">
          <FloatingLabel
            label="Email Address"
            controlId="floatingInput"
            className="mb-3"
          >
            <Form.Control
              type="text"
              placeholder="Email Address"
              value={login.EmailId}
              name="EmailId"
              onChange={handleChange}
            />
          </FloatingLabel>
          <FloatingLabel label="Password" controlId="floatingInput">
            <Form.Control
              type="password"
              placeholder="Password"
              value={login.password}
              name="password"
              onChange={handleChange}
            />
          </FloatingLabel>
          <div className="text-center">
            <button
              type="button"
              onClick={() => handleSummit()}
              className="btn sitebtn mt-4"
            >
              Sign in
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Login;
